import axios from "../../config/axiosConfig";
import {
  SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_REQUEST,
  SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_SUCCESS,
  SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_FAILURE,
  SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_REQUEST,
  SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_SUCCESS,
  SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_FAILURE
} from "../types/sub-job-pending-receive-gray-report-types";

export const getSubJobPendingReceiveGrayReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/sub-job-pending-receive/gray?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sub Job Pending Stock Receive Report:", error);
        dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sub Job Pending Stock Receive Report:", error);
      dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getSubJobPendingReceiveGrayFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_REQUEST });
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/sub-job-pending-receive/filter-detail/gray?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sub Job Pending Stock Receive Report:", error);
        dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sub Job Pending Stock Receive Report:", error);
      dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearSubJobPendingReceiveGrayReport = () => {
  return async (dispatch) => {
    dispatch({ type: SUB_JOB_PENDING_RECEIVE_GRAY_REPORT_SUCCESS, payload: {} });
  }
}
